import { makeRequired } from 'CorePackage/MainModule/validators/isRequired';
import { IKnmFormDocument } from 'KnmPackage/KnmDocumentsModule/interfaces/IKnmFormDocument';
import { REQUIRED_ERROR } from 'CorePackage/MainModule/constants/validationErrors';

import { IKnmErknmFormEvent } from '../interfaces/IKnmErknmFormEvent';

const documentCommonRequired = (
  document: IKnmFormDocument | undefined,
): { [key: string]: string } | string | undefined => {
  if (!document) {
    // eslint-disable-next-line no-param-reassign
    document = {
      active: null,
      attachments: undefined,
      correlationToken: null,
      description: null,
      guid: null,
      type: undefined,
      listId: '',
    };
  }

  return {
    attachments: makeRequired(REQUIRED_ERROR)(document?.attachments),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } as any;
};

export const getActEventProtocolValidator = (item: IKnmErknmFormEvent) => {
  if (!item.actionNotPerformed && item.type?.label !== 'Осуществляется без действия') {
    return {
      file: documentCommonRequired(item.protocol?.file),
    };
  }

  return undefined;
};
